import { SET_GENERAL_DATA } from './types'
import { contentPage } from 'src/services/ContentApi'

export const general = (language) => async (dispatch) => {
  try {
    const generalData = await contentPage('site_generalsettings', language)
    dispatch({ type: SET_GENERAL_DATA, payload: generalData })
  } catch (error) {
    throw error
  }
}
